import { render } from "./CourseRelationButton.vue?vue&type=template&id=1b1d1731&scoped=true"
import script from "./CourseRelationButton.vue?vue&type=script&lang=js"
export * from "./CourseRelationButton.vue?vue&type=script&lang=js"

import "./CourseRelationButton.vue?vue&type=style&index=0&id=1b1d1731&scoped=true&lang=css"
import "./CourseRelationButton.vue?vue&type=style&index=1&id=1b1d1731&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d1731"]])

export default __exports__